<template>
  <div>
    <!-- 搜索框 -->
    <div class="search-root pcSearch" v-if="!isMobile">
      <div class="searchBlock">
        <div class="search-form">
          <div class="icon">
            <img src="../assets/pubmedSearch/search.png">
          </div>
          <div class="inputItem" v-on-clickaway="clickAway">
            <input
              type="text"
              placeholder="请在此输入中文/英文检索字段"
              v-model="inputKeyword"
              @keydown.13="beginSearch"
              @focus="pcInputFocus"
              @input="pcInput"
            >
            <div
              class="hisList"
              v-if="showHis"
            >
              <div class="hisItem" v-for="(item, index) in searchHis" :key="item.id" :class="{'noBorderTop': index == 0}">
                <div class="hisContext" @click="searchFromHis(item.search)">
                  <img
                    src="../assets/pubmedSearch/history.png"
                    alt="搜索历史"
                  >
                  <span>{{item.search}}</span>
                </div>
                <img
                  src="../assets/pubmedSearch/del.png"
                  alt="删除"
                  class="delHis"
                  @click="delHis(index,item.id)"
                >
              </div>
              
            </div>
          </div>
          <div
            class="searchBtn"
            @click="beginSearch"
          >搜索</div>
        </div>
      </div>
    </div>
    <div class="mobileSearch" v-on-clickaway="clickAway" v-if="isMobile">
        <van-search placeholder="请在此输入中文/英文检索字段" show-action  v-model="inputKeyword"  @focus="pcInputFocus" @input="pcInput" @search="beginSearch">
          <div slot="action" @click="beginSearch">搜索</div>
        </van-search>
        <!-- 历史纪录 -->
        <div  class="hisList" v-if="showHis">
              <div class="hisItem" v-for="(item, index) in searchHis" :key="item.id" :class="{'noBorderTop': index == 0}">
                <div class="hisContext" @click="searchFromHis(item.search)">
                  <img
                    src="../assets/pubmedSearch/history.png"
                    alt="搜索历史"
                  >
                  <span>{{item.search}}</span>
                </div>
                <img
                  src="../assets/pubmedSearch/del.png"
                  alt="删除"
                  class="delHis"
                  @click="delHis(index,item.id)"
                >
              </div>
              
            </div>
    </div>
    <div v-show="isFirst" class="firstNoData">
        <img src="../assets/pubmedSearch/initNoData.png" alt="" class="mobileNodata">
        <img src="../assets/pubmedSearch/pcInitNoData.png" alt="" class="pcNodata">
    </div>
    <!--  搜索内容  -->
    <transition enter-active-class="animated bounceInUp faste" leave-active-class="animated bounceOutDown faster">
    <div class="rootBox" v-show="!isFirst"  v-loading="loading"  element-loading-text="拼命加载中"  element-loading-spinner="el-icon-loading" element-loading-background="rgba(234, 235, 237, 0.8)">
      <div class="filterBox">
        <div class="pcDrop">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              影响因子<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{filters:item,from:'journal'}" v-for="(item, index) in pcJournal" :key="index">{{item}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              文献类型<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{filters:item,from:'tags'}" v-for="(item, index) in pcTags" :key="index">{{item}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              发表时间<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{filters:item,from:'recency'}" v-for="(item, index) in pcRecency" :key="index">{{item | padTime}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div
          class="mobileDrop"
          :class="{'is_fixed':isFixed}"
          ref="mobileDrop"
        >
          <van-dropdown-menu :class="{'fixedStyle' : isFixed}">
            <van-dropdown-item
              v-model="value1"
              :options="mbJournal"
              @change='mobilFilter'
              title="影响因子"
            />
            <van-dropdown-item
              v-model="value2"
              :options="mbTags"
              @change='mobilFilter'
              title="文献类型"
            />
            <van-dropdown-item
              v-model="value3"
              :options="mbRecency"
              @change='mobilFilter'
              title="发表时间"
            />
          </van-dropdown-menu>
        </div>
        <div class="resultCount">
          共搜索出<span class="resultNum">{{numFound}}</span>条结果
        </div>
      </div>
      
      <div class="resultList" v-show="!showModel">
        <div class="resultItem" v-for="(item, index) in resultList" :key="item.pmid">
          <div class="baseinfo">
            <div class="title">
              <span class="infoIndex">{{isMobile ? index + 1 : (currentPage-1) * 10 + (index+1)}}.</span>
              <span>{{item.showChinese ? item.title_cn :item.title_en}}</span>
            </div>
            <div class="from">
              <span>期刊：</span>{{item.journal_iso}}
            </div>
            <div class="author">
              <span>影响因子:</span>{{item.journal_if}}
            </div>
            <div class="yub-year">
              <span>发表年份：</span>{{item.pubdate}}
            </div>
            <div class="keys clearfix"  v-if="item.C">
              <span>疾病：</span>
              <div class="keyDetail">
                  <span v-for="(item1, index1) in item.C" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != item.C.length"> | </i></span>
              </div>
            </div>
            <div class="keys" v-if="item.D">
              <span>药品：</span>
              <div class="keyDetail">
                  <span v-for="(item1, index1) in item.D" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != item.D.length"> | </i></span>
              </div>
            </div>
            <div class="keys" v-if="item.Z">
              <span>地理位置：</span>
              <div class="keyDetail">
                  <span v-for="(item1, index1) in item.Z" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != item.Z.length"> | </i></span>
              </div>
            </div>
          </div>
          <div
            class="highline"
            :class="{'highlineFold' : !item.isFold}"
          >
          <!--  :style="styleObj" -->
            <span class="key">重点信息：</span>
            <!-- <span class="description">{{item.showChinese ? item.key_information_cn : item.key_information}}</span> -->
            <div class="description">
              <div class="desItem" v-for="(item1, index1) in item.showChinese ? item.key_information_cn : item.key_information" :key="index1">
                <span class="desItemTitle">{{item1[0]}}:</span>
                <span>{{item1[1]}}</span>
              </div>
            </div>
          </div>
          <div class="buttons">
            <div class="more" @click="viewFull(item.pmid)">查看更多</div>
            <div class="translate-highline" :class="{ 'loading': item.showLoading}" @click="translateKeyInfor(item)"><span>翻译重点信息</span></div>
            <div class="toggleColl" @click="toggleFold(item)"><span>{{item.isFold ? '展开' : '收起'}}</span></div>
          </div>
        </div>
        <!-- 没有数据 -->
        <div class="nulllist" v-if="resultList.length == 0">
          <p>暂无搜索结果</p>
        </div>
      </div>
      <div class="paginations"  v-show="!showModel">
        <div class="pcPage">
          <el-pagination
            layout="prev, pager, next"
            :total="numFound"
            :hide-on-single-page="true"
            :current-page.sync="currentPage"
            @current-change='pageChange'
          >
          </el-pagination>
        </div>
        <div class="mobilePage" :class="{'loading':loadMoreLoading}" @click="loadMore" v-if="resultList.length !== 0">
          {{loadMoreText}}
        </div>
      </div>
      <!-- 详情弹窗 -->
      <transition enter-active-class="animated zoomIn faster" leave-active-class="animated bounceOut faster">
      <div
        class="search-result-pop"
        v-show="showModel"
        v-loading="loadingDetail"  element-loading-text="拼命加载中"  element-loading-spinner="el-icon-loading" element-loading-background="rgba(234, 235, 237, 0.8)"
      >
        <div class="search-result-pop-content">
          <div class="title"><span>{{docDetail.showChinese ? docDetail.title_cn : docDetail.title_en}}</span></div>
          <div class="author"><span>PMID：</span>{{docDetail.pmid}}</div>
          <div class="author"><span>作者：</span>{{docDetail.author}}</div>
          <div class="from"><span>期刊：</span>{{docDetail.journal_name}}</div>
          <div class="from"><span>影响因子：</span>{{docDetail.journal_if}}</div>
          <div class="yub-year"><span>发表年份：</span>{{docDetail.pubdate | splitTime}}</div>
          <div class="page-number"><span>期卷页码：</span>{{docDetail.pages}}</div>
          <div class="keys clearfix" v-if="docDetail.V">
            <span class="subTitle">论文类型：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.V" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.V.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix" v-if="docDetail.C">
            <span class="subTitle">疾病：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.C" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.C.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.D">
            <span class="subTitle">药品：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.D" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.D.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.Z">
            <span class="subTitle">地理位置：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.Z" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.Z.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.M">
            <span class="subTitle">人群：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.M" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.M.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.A">
            <span class="subTitle">部位与器官：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.A" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.A.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.B">
            <span class="subTitle">生物种类：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.B" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.B.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.G">
            <span class="subTitle">生物科学关键词：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.G" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.G.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.N">
            <span class="subTitle">医疗研究关键词：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.N" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.N.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.E">
            <span class="subTitle">实验技术与仪器：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.E" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.E.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.F">
            <span class="subTitle">精神病学与心理学关键词：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.F" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.F.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.L">
            <span class="subTitle">信息科学关键词：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.L" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.L.length"> | </i></span>
            </div>
          </div>
          <div class="keys clearfix"  v-if="docDetail.H">
            <span class="subTitle">物理学关键词：</span>
            <div class="keyDetail">
                <span v-for="(item1, index1) in docDetail.H" :key="index1">{{`${item1[0]}(${item1[1]})`}} <i class="separator" v-if="index1 + 1 != docDetail.H.length"> | </i></span>
            </div>
          </div>
          
          <div class="summary">
            <div class="key">摘要：</div>
            <div class="desBox">
              <div class="description" v-for="(item, index) in (docDetail.showChinese ? docDetail.abstract_cn : docDetail.abstract_en)" :key="index">
                {{item}}
              </div>
            </div>
          </div>
          <div class="button-tips">
            <div class="buttons">
              <div class="view-fullstory" @click="viewFullDoc"><span>查看全文</span></div>
              <div class="translate-summary" @click="translateDetail" :class="{ 'loading': docDetail.showLoading}"><span>翻译摘要</span></div>
            </div>
          </div>
        </div>
        <div class="close" @click="closeDetailModel">关闭</div>
      </div>
      </transition>
    </div>
    </transition>
  </div>
</template>
<script>
import { md5 } from 'md5js';
import { browser } from '../config/ua'
import { directive as onClickaway } from 'vue-clickaway';
import { handleSearch , getFilters , translateInfo ,getDocDetail, getHis , delHisHandle } from '../service/getData'
export default {
  data() {
    return {
      isMobile:browser.ua.mobile,// 是否是手机，用于避免vue-clickaway冲突,搜索框pc和手机上只会渲染一个，故浏览器切换手机电脑可能不显示
      loading:false,// 搜索loading
      loadingDetail:false,//加载详情页loading
      loadMoreLoading:false,// 手机端加载更多loading
      isFirst:true,// 默认第一次进来只有搜索框
      inputKeyword:'',// 用户输入的关键字
      keyword: "", // 实际使用的关键字
      showHis: false, // 是否显示历史纪录
      searchHis:[],// 搜索历史记录
      currentPage:1,// 当前页码
      numFound:0,// 查询的总条数
      resultList:[], // 查询的结果
      loadMoreText:'加载更多',
      showModel:false,
      pcJournal:[],// pc组件的筛选条件
      pcRecency:[],
      pcTags:[],
      pcFilters:{
        journal:'',
        recency:'',
        tags:'',
      },// pc已选得筛选条件
      value1: '全部',
      value2: '全部',
      value3: '全部',
      mbJournal: [],
      mbRecency: [],
      mbTags: [],
      isFixed: false,
      offsetTop:94, // 手机端筛选框距离顶部距离
      docDetail:{},// 文章详情内容
      scrolltop:0,// 点击详情页时候得滚动距离
    };
  },
  methods: {
    // 发起搜索
     async beginSearch(){
      if(this.inputKeyword.trim() == ''){
         alert('您还没有输入任何内容哦')
         return;
      }
      this.keyword = this.inputKeyword;
      if(this.isFirst){
        this.isFirst = false;
      }
      if(this.showModel){ // 点开详情页得情况下点击搜索
        this.showModel = false;
      }
      this.loading = true;
      this.pcFilters = { // 每次搜索重新初始化筛选条件
        journal:'',
        recency:'',
        tags:'',
      }
      let res = await this.searchContext(10,1)
      this.loading = false;
      if(res.status == 0){
        res.data.forEach(item => {
           item.isFold = true; // 默认折叠
           item.hasTranslated = false;// 是否经过翻译
           item.showChinese = false;//  是否显示中文
           item.showLoading = false;// 是否显示翻译loading
        });
        this.resultList = res.data;
        this.numFound = res.numFound;
      } else if(res.status == 1){
        alert('无法识别的输入')
      } else {
        alert('网络异常')
      }
      
    },
    // 搜索
    async searchContext(limit,currentPage,journal_if = '',tags = '',recency = ''){
       const params = {
        "keyword": this.keyword,
        "filters": {
            "journal_if": journal_if,
            "tags": tags,
            "recency": recency
        },
        "pages": {
            "limit": limit,
            "currentPage": currentPage
        }
      }
      const res = await handleSearch(params);
      return res.data
    },
    // 获取筛选条件
    async getFilterOpt(){
        const res = await getFilters();
        if(res && res.data.status == 0){
          let {journal_if,recency,tags} = res.data.data;
          // pc
          this.pcJournal = journal_if;
          this.pcRecency = recency;
          this.pcTags = tags;
          // mobile
          let copyJournal = ['全部',...journal_if]
          let copyrecency = ['全部',...recency]
          let copytags = ['全部',...tags]
          this.mbJournal  = copyJournal.reduce(function(arr,item){
            let obj = {text:item,value:item}
            arr.push(obj)
            return arr
          },[])
          this.mbRecency = copyrecency.reduce(function(arr,item){
              let obj
              if(item == '全部'){
                obj = {text:item,value:item}
              } else {
                obj = {text:`近${item}年`,value:item}
              }
              arr.push(obj)
              return arr
          },[])
          this.mbTags = copytags.reduce(function(arr,item){
              let obj = {text:item,value:item}
              arr.push(obj)
              return arr
          },[])

        } else {
          // this.getFilterOpt();
        }
       
    },
    // 获取历史记录
    async loadHistory(){
      let res = await getHis();
      if(res && res.data.status == 0){
        let { data } = res.data;
        this.searchHis = data;
      }
    },
    // pc搜索框获取焦点
    pcInputFocus(){
      if(this.searchHis.length == 0 || this.keyword.trim() != ''){
        this.showHis = false;
      } else {
        this.loadHistory();// 获取历史纪录
        this.showHis = true;
      }
    },
    // 点击历史纪录框外面
    clickAway(){
      // console.log('away');
      this.showHis = false;
    },
    // pc开始输入
    pcInput(){
      if(this.showHis){
        this.showHis = false;
      }
    },
    // 删除历史记录
    async delHis(index,id){
      this.searchHis.splice(index,1);
      if(this.searchHis.length == 0){
        this.showHis = false;
      }
      await delHisHandle({id});
    },
    // 点击历史记录进行搜索
    searchFromHis(keyword){
      this.inputKeyword = keyword;
      this.keyword = keyword;
      this.beginSearch();
      if(this.showHis){
        this.showHis = false;
      }

    },
    // pc发起条件搜索
    async handleCommand(command) {
      this.pcFilters[command.from] = command.filters;
      this.loading = true;
      this.inputKeyword =  this.keyword;
      let res = await this.searchContext(10,1,this.pcFilters.journal,this.pcFilters.tags,this.pcFilters.recency)
      this.loading = false;
      if(res.status == 0){
        this.currentPage = 1;
        res.data.forEach(item => {
           item.isFold = true; // 默认折叠
           item.hasTranslated = false;// 是否经过翻译
           item.showChinese = false;//  是否显示中文
           item.showLoading = false;// 是否显示翻译loading
        });
        this.resultList = res.data;
        this.numFound = res.numFound;
      }

    },
    // 手机端筛选
    async mobilFilter(){
      let journal = this.value1 == '全部' ? '' : this.value1;
      let tags = this.value2 == '全部' ? '' : this.value2;
      let recency = this.value3 == '全部' ? '' : this.value3;
      let res = await this.searchContext(10,1,journal,tags,recency)
      if(res.status == 0){
        this.currentPage = 1;
        res.data.forEach(item => {
           item.isFold = true; // 默认折叠
           item.hasTranslated = false;// 是否经过翻译
           item.showChinese = false;//  是否显示中文
           item.showLoading = false;// 是否显示翻译loading
        });
        this.resultList = res.data;
        this.numFound = res.numFound;
      }
      this.inputKeyword =  this.keyword;
    },
    // pc页码改变,覆盖原有数据
    async pageChange(value){
      this.currentPage = value;
      this.inputKeyword =  this.keyword;
      let res = await this.searchContext(10,value,this.pcFilters.journal,this.pcFilters.tags,this.pcFilters.recency)
      if(res.status == 0){
        res.data.forEach(item => {
           item.isFold = true; // 默认折叠
           item.hasTranslated = false;// 是否经过翻译
           item.showChinese = false;//  是否显示中文 
           item.showLoading = false;// 是否显示翻译loading

        });
        this.resultList = res.data;
        this.numFound = res.numFound;
        this.$nextTick(() => {
          document.documentElement.scrollTop = 0;
        })
      }

    },
    // 手机端加载更多
    async loadMore(){
      let totalPage = this.numFound % 20 == 0 ? parseInt(this.numFound/20) : parseInt(this.numFound/20) + 1;
      if(this.currentPage >= totalPage){
        this.loadMoreText = '没有更多了'
        return;
      }
      this.loadMoreLoading = true;
      let nextPage = this.currentPage + 1;
      this.currentPage = nextPage;
      let journal = this.value1 == '全部' ? '' : this.value1;
      let tags = this.value2 == '全部' ? '' : this.value2;
      let recency = this.value3 == '全部' ? '' : this.value3;

      let res = await this.searchContext(20,nextPage,journal,tags,recency);
      this.loadMoreLoading = false;
      if(res.status == 0){
        res.data.forEach(item => {
           item.isFold = true; // 默认折叠
           item.hasTranslated = false;// 是否经过翻译
           item.showChinese = false;//  是否显示中文
           item.showLoading = false;// 是否显示翻译loading

        });
        this.resultList = [...this.resultList,...res.data];
        this.numFound = res.numFound;
      }
      this.inputKeyword =  this.keyword;

    },
    // 查看更多按钮,进入详情页
    async viewFull(pmid){
      this.scrolltop = document.documentElement.scrollTop;
      this.showModel = true;
      this.loadingDetail = true;
      let res = await getDocDetail({pmid:pmid});
      this.loadingDetail = false;
      if(res.data.status == 0){
        const obj = {...res.data.data};
        obj.pmid = pmid;
        obj.hasTranslated = false;// 是否经过翻译
        obj.showChinese = false;//  是否显示中文
        obj.showLoading = false;// 是否显示翻译loading
        this.docDetail = obj;
      } else {
        alert('网络错误')
      }
    },
    // 翻译重点信息
    async translateKeyInfor(item){

        if(item.hasTranslated){ // 已经翻译过的不再请求，从本地拿
            item.showChinese = !item.showChinese;
            return;
        }

        item.showLoading = true;// 加载中
        let secret = 'afd0b036bz625abz3aa8bzb639bz9dc8c8fff0ff'
        let ts = new Date().getTime();
        let tokenStr = `${1}.bz.${ts}.bz.${item.pmid}.bz.${secret}`
        let token = md5(tokenStr,32)

        const params = {
          "client_id": "1",
          "ts": Number(ts),
          "pmid": String(item.pmid),
          "types": "cn_key",
          "token":token
      }
      let res = await translateInfo(params)
        item.showLoading = false;
      if(res.data.status == 0){
        let {title:title_cn,sentence:key_information_cn} = res.data.data
        item.title_cn = title_cn;
        item.key_information_cn = key_information_cn;
        item.hasTranslated = true;
        item.showChinese = true;
      } else if(res.data.status == -1) {
          alert('请求超时，稍后再试')
      } else {
        alert('网络错误')
      }
    },
    // 翻译全文
    async translateDetail(){
      if(this.docDetail.hasTranslated){ // 已经翻译过的不再请求，从本地拿
            this.docDetail.showChinese = !this.docDetail.showChinese;
            return;
        }

        this.docDetail.showLoading = true;// 加载中
        let secret = 'afd0b036bz625abz3aa8bzb639bz9dc8c8fff0ff'
        let ts = new Date().getTime();
        let tokenStr = `${1}.bz.${ts}.bz.${this.docDetail.pmid}.bz.${secret}`
        let token = md5(tokenStr,32)
        let _this = this;
        const params = {
          "client_id": "1",
          "ts": Number(ts),
          "pmid": String(_this.docDetail.pmid),
          "types": "cn_full",
          "token":token
      }
      let res = await translateInfo(params)
        this.docDetail.showLoading = false;
      if(res.data.status == 0){
        let {title:title_cn,sentence:abstract_cn} = res.data.data
        this.docDetail.title_cn = title_cn;
        this.docDetail.abstract_cn = abstract_cn;
        this.docDetail.hasTranslated = true;
        this.docDetail.showChinese = true;
      } else if(res.data.status == -1) {
          alert('请求超时，稍后再试')
      } else {
        alert('网络错误')
      }

    },
    // 查看全文
    viewFullDoc(){
      window.open(this.docDetail.full_link)
    },
    // 重点信息的展开和收起
    toggleFold(item){
      item.isFold = !item.isFold
    },
    // 手机端下拉筛选框的吸顶
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.isFixed = scrollTop > this.offsetTop ? true : false;
    },
    // 关闭详情页面回到当前位置
    closeDetailModel(){
      this.showModel = false;
      this.$nextTick(() => {
        document.documentElement.scrollTop = this.scrolltop;
      })
    },
  },
  filters:{
    // 补全筛选条件（发表时间）
    padTime(time){
      return `近${time}年`
    },
    // 详情页发表时间处理
    splitTime(time){
      if(!time){
        return time;
      } else {

        return time.split('T')[0];
      }
    }
  },
  directives:{
    onClickaway: onClickaway,
  },
  mounted() { 
    this.getFilterOpt(); // 获取筛选条件
    this.loadHistory();// 获取历史纪录
    window.addEventListener("scroll", this.handleScroll);
    // this.$nextTick(() => {
    //   this.offsetTop = this.$refs.mobileDrop.getBoundingClientRect().top
    //   this.offsetTop = this.$refs.mobileDrop.offsetTop;
    // });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #707070;
}
.el-icon-arrow-down {
  font-size: 14px;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: transparent;
  color: #85b5ff;
}

@media only screen and (min-width: 768px) {
  .mobileSearch {
    display: none
  }
  .searchBlock {
    background: #fff;
  }
  .search-form {
    position: relative;
    width: 610px;
    margin: 0 auto;
    margin-top: -43px;
    display: flex;
  }
  .icon {
    width: 60px;
    height: 80px;
    border: 1px solid #f8f8f8;
    border-radius: 40px 0 0 40px;
    border-right: none;
    background: #fff;
    box-sizing: border-box;
    box-shadow: -1px 2px 1px #e1edff;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    user-select: none;
  }
  .inputItem {
    position: relative;
    width: 430px;
    height: 80px;
  }
  .inputItem input {
    width: 430px;
    height: 80px;
    padding: 20px 25px;
    box-sizing: border-box;
    font-size: 18px;
    color: #333;
    border: 1px solid #f8f8f8;
    border-right: none;
    border-left: none;
    outline: none;
    background: #fff;
    box-shadow: 1px 2px 1px #e1edff;
  }
  input::-webkit-input-placeholder {
    color: #666666;
    font-size: 18px;
    /* font-weight: bold; */
  }
  .searchBtn {
    width: 108px;
    height: 80px;
    border: 1px solid #f8f8f8;
    text-align: center;
    line-height: 80px;
    font-size: 18px;
    font-weight: bold;
    color: #72aaff;
    background: #fff;
    border-radius: 0 40px 40px 0;
    box-shadow: 1px 2px 1px #e1edff;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
  }
  .firstNoData {
    width: 797px;
    margin: 0 auto;
    margin-top: 140px;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .firstNoData img {
      width: 330px;
  } 
  .firstNoData img.mobileNodata {
    display: none;
  }

  .hisList {
    position: absolute;
    left: -33px;
    top: 81px;
    width: 540px;
    background: #fff;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 0 0 8px 8px;
    border: 1px solid #c2c2c2;
    border-top: none;
    z-index: 14;
  }
  .hisItem {
    /* height: 61px; */
    padding: 15px 10px 15px 0;
    /* box-sizing: border-box; */
    border-top: 1px dashed #d8cfcf;
    color: #999999;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .noBorderTop {
    border-top: none;
  }
  .hisContext {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .delHis {
    cursor: pointer;
  }

  /* 内容区域 */
  .mobileDrop,
  .mobilePage {
    display: none;
  }
  .rootBox {
    position: relative;
    width: 797px;
    border: 2px solid #f0f0f0;
    border-radius: 10px;
    padding: 27px;
    margin: 50px auto;
  }
  .filterBox {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .el-dropdown {
    margin-right: 25px;
  }
  .resultList {
    margin-top: 20px;
  }
  .resultCount {
    font-size: 14px;
    color: #707070;
  }
  .resultItem {
    padding: 20px 0;
    border-bottom: 1px solid #eee;
  }
  .resultNum {
    color: #85b5ff;
  }

  .baseinfo .title {
    padding-right: 40px;
    font-size: 18px;
    color: #000;
    line-height: 24px;
    margin-bottom: 9px;
    font-weight: 500;
    -webkit-tap-highlight-color: transparent;
  }
  
  .baseinfo .title .infoIndex {
    /* color:#72aaff; */
    margin-right:4px;
    font-size:16px;
    /* font-weight: 500; */
    }
  .baseinfo::after {
    display: block;
    content: "";
    clear: both;
  }
  .baseinfo .author {
    width: 26%;
  }
  .baseinfo .from {
    width: 50%;
  }
  .baseinfo .author,
  .baseinfo .from,
  .baseinfo .yub-year {
    float: left;
    height: 22px;
    line-height: 22px;
    font-size: 13px;
    color: #333;
    /* overflow: hidden; */
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .baseinfo .keys {
    display: flex;
    width: 100%;
    /* height: 22px; */
    line-height: 22px;
    font-size: 13px;
    color: #333;
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    /* white-space: nowrap; */
  }
  .baseinfo .clearfix {
    /* display: block;
    content: ''; */
    clear: both;
  }
  .baseinfo .keys .keyDetail {
    width: 732px;
    /* display: flex; */
  }
  .baseinfo .keys .keyDetail .separator {
    font-style: normal;
    font-size: 14px;
    margin-left: 4px;
  }
  .baseinfo .keys .keyDetail span {
    float: left;
    margin-right: 5px;
  }
  .highline {
    position: relative;
    clear: both;
    max-height: 66px;
    line-height: 22px;
    font-size: 13px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
  }
  .highlineFold {
    -webkit-line-clamp: inherit;
    max-height: none;
  }
  .highline .key {
    font-weight: 500;
    color: #000;
    vertical-align: top;
  }
  .highline .description {
    /* margin-left: 10px; */
    vertical-align: top;
  }
  .highline .description .desItemTitle {
    font-weight: 500;
  }
  .buttons {
    position: relative;
    height: 20px;
  }
  .buttons .more {
    float: left;
    display: inline-block;
    font-size: 13px;
    color: #0172c2;
    line-height: 1;
    padding: 3.5px 0 3.5px 18px;
    margin-right: 50px;
    cursor: pointer;
    background: url("../assets/pubmedSearch/more.png") no-repeat 0 2.5px;
    background-size: 15px;
  }
  .buttons .translate-highline {
    float: left;
    display: inline-block;
    font-size: 13px;
    color: #0172c2;
    line-height: 1;
    margin-right: 50px;
    text-align: center;
  }
  .buttons .translate-highline span {
    line-height: 1;
    padding: 3.5px 0 3.5px 18px;
    cursor: pointer;
    display: inline-block;
    background: url("../assets/pubmedSearch/translation.png") no-repeat 0 3px;
    background-size: 15px;
  }
  .buttons .loading span::after {
    content: "";
    padding-right: 14px;
    background: url("../assets/pubmedSearch/loading.gif") no-repeat center right;
    background-size: 12px;
  }
  .buttons .toggleColl {
    position: absolute;
    right: 0;
    top: -30px;
    height: 23px;
  }
  .buttons .toggleColl span {
    position: relative;
    z-index: 1;
    display: inline-block;
    width: 40px;
    height: 23px;
    line-height: 23px;
    text-align: center;
    font-size: 12px;
    color: #0172c2;
    background-color: #efefef;
    -webkit-border-radius: 11.5px;
    -moz-border-radius: 11.5px;
    -ms-border-radius: 11.5px;
    border-radius: 11.5px;
    cursor: pointer;
    vertical-align: top;
  }
  .pcPage {
    margin-top: 40px;
    text-align: center;
  }
  .nulllist {
    padding-top: 107px;
  }
  .nulllist p {
    margin: 0;
    padding-top: 100px;
    font-size: 13px;
    color: #888;
    background: url("../assets/pubmedSearch/no-result.png") no-repeat center top;
    background-size: 91px;
    text-align: center;
  }
  /* 详情弹框 */
  .search-result-pop {
    -webkit-tap-highlight-color: transparent;
    position: absolute;
    top: -3px;
    left: -3px;
    /* left: 50%; */
    width: 857px;
    padding: 20px 30px 40px;
    margin-bottom: 100px;
    background-color: #fff;
    border: 1px solid #eee;
    z-index: 12;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
    /* -ms-transform: translate(-50%, 0);
    -moz-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0); */
  }
  /* .search-result-pop-content {
    overflow-y: scroll;
  } */
  .search-result-pop .title {
    font-size: 18px;
    line-height: 27px;
    color: #000;
    margin-bottom: 6px;
    font-weight: 500;
    margin-right: 70px;
  }
  .search-result-pop .author,
  .search-result-pop .from {
    margin-right: 60px;
    color: #333;
    line-height: 22px;
    font-size: 13px;
  }
  .search-result-pop .yub-year,
  .search-result-pop .page-number,
  .search-result-pop .summary {
    color: #333;
    line-height: 22px;
    font-size: 13px;
  }
  .search-result-pop .keys {
    display: flex;
    color: #333;
    line-height: 22px;
    font-size: 13px;
  }
  .search-result-pop .keys span.subTitle {
    font-weight: bold;
  }
  .search-result-pop .keys .keyDetail {
    width: 635px;
  }
  .search-result-pop .keys .keyDetail span {
    float: left;
    margin-right: 5px;
  }
  .search-result-pop .keys .keyDetail .separator {
    font-style: normal;
    font-size: 14px;
    margin-left: 4px;
  }
  .search-result-pop .summary {
    /* display: flex; */
    margin-bottom: 10px;
  }
  .search-result-pop .author span,
  .search-result-pop .from span,
  .search-result-pop .yub-year span,
  .search-result-pop .page-number span,
  .search-result-pop .summary .key {
    /* width: 40px; */
    font-weight: bold;
  }
  /* .search-result-pop .summary .desBox {
    width: 755px;
  } */

  .search-result-pop .buttons {
    position: relative;
    text-align: left;
  }
  .search-result-pop .buttons .view-fullstory,
  .search-result-pop .buttons .translate-summary {
    display: inline-block;
    margin-right: 60px;
    line-height: 1;
    color: #0172c2;
    font-size: 14px;
    cursor: pointer;
  }
  .search-result-pop .buttons .view-fullstory span {
    line-height: 1;
    padding: 3.5px 0 3.5px 18px;
    background: url("../assets/pubmedSearch/viewFull.png") no-repeat 0 4px;
    background-size: 15px;
  }
  .search-result-pop .buttons .translate-summary span {
    padding: 3.5px 0 3.5px 18px;
    background: url("../assets/pubmedSearch/translation.png") no-repeat 0 center;
    background-size: 15px;
  }
  .search-result-pop .close {
    position: absolute;
    top: 20px;
    right: 30px;
    width: 67px;
    height: 29px;
    line-height: 29px;
    font-size: 14px;
    text-indent: 0;
    border: 1px solid #0172c2;
    color: #0172c2;
    padding-left: 29px;
    cursor: pointer;
    -webkit-border-radius: 15px;
    -moz-border-radius: 15px;
    -ms-border-radius: 15px;
    border-radius: 15px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
    background: #fff url("../assets/pubmedSearch/close.png") no-repeat 12px 9px;
    background-size: 11px;
  }
}

@media only screen and (max-width: 767px) and (min-width: 414px) {
  .pcSearch {
    display: none
  }
  .mobileSearch {
    background: #ededed;
    position: relative;
    /* BFC */
    border-top: 1px solid #ededed; 
    border-bottom: 1px solid #ededed;
  }
  .van-search {
    padding: 10px;
    margin:20px;
    background: #fff;
    border-radius: 15px;
  }
  .van-search__content {
    background-color: #fff;
  }
  .van-search__action {
    color: #72aaff;
    font-weight: bold;
    font-size: 15px;
  }
  .van-cell >>> .van-cell__value {
     padding-right: 7px;
    border-right: 1px solid #c5c1c1;
  }
 
  .firstNoData {
    width: 100vw;
    height: calc(100vh - 95px);
    background: #ededed;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .firstNoData img {
      width: 260px;
  } 
  .firstNoData .pcNodata {
    display: none;
  }
  .search-root {
    background: #f4f4f4;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .searchBlock {
    background: #fff;
    border-radius: 8px;
    margin: 0 10px;
  }
  .search-form {
    position: relative;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
  .icon {
    display: none;
  }
  .inputItem {
    position: relative;
    width: 100%;
  }
  .inputItem input {
    width: 100%;
    height: 48px;
    line-height: inherit;
    margin-bottom: 10px;
    padding: 0 13px;
    border: none;
    font-size: 15px;
    outline: none;
    box-shadow: none;
    border-radius: 8px;
    background-color: #f3f3f3;
    box-sizing: border-box;
  }
  input::-webkit-input-placeholder {
    color: #666666;
    font-size: 15px;
  }
  .searchBtn {
    height: 46px;
    width: 100%;
    font-size: 16px;
    text-indent: 0;
    color: #fff;
    background: #0172c2;
    border-radius: 23px;
    text-align: center;
    line-height: 46px;
  }

  .hisList {
    position: absolute;
    left: 30px;
    top: 75px;
    min-width: 340px;
    background: #fff;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 0 0 8px 8px;
    border: 1px solid #c2c2c2;
    border-top: none;
    z-index: 14;
  }
  .hisItem {
    /* height: 61px; */
    padding: 20px 10px 20px 0;
    /* box-sizing: border-box; */
    border-top: 1px dashed #d8cfcf;
    color: #999999;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .noBorderTop {
    border-top: none;
  }
  
  .hisContext {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .hisContext img {
    margin-right: 5px;
  }
  .delHis {
    cursor: pointer;
    margin-left: 15px;
  }

  /* 内容区域 */
  .pcDrop,
  .pcPage {
    display: none;
  }
  .is_fixed {
    height: 50px;
  }
  .fixedStyle {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1
  }
  .rootBox {
    margin: 0 auto;
    background-color: #f4f4f4;
  }

  .resultItem {
    padding: 19px;
    background: #fff;
    margin-top: 5px;
  }
  .el-dropdown {
    margin-right: 25px;
  }
  .resultCount {
    text-align-last: center;
    font-size: 14px;
    color: #707070;
    line-height: 18px;
    margin-top: 5px;
  }
  .resultNum {
    color: #85b5ff;
  }
  .baseinfo .title {
    padding-right: 40px;
    font-size: 18px;
    color: #000;
    line-height: 24px;
    margin-bottom: 9px;
    font-weight: 500;
    -webkit-tap-highlight-color: transparent;
  }
  .baseinfo .title .infoIndex {
    /* color:#72aaff; */
    margin-right:4px;
    font-size:16px;
    /* font-weight: 500; */
    }
  .baseinfo::after {
    display: block;
    content: "";
    clear: both;
  }
  /* .baseinfo .author {
    width: 26%;
  }
  .baseinfo .from {
    width: 50%;
  } */
  .baseinfo .author,
  .baseinfo .from,
  .baseinfo .yub-year {
    /* float: left; */
    height: 22px;
    line-height: 22px;
    font-size: 13px;
    color: #333;
    /* overflow: hidden; */
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .baseinfo .keys {
    display: flex;
    width: 100%;
    /* height: 22px; */
    line-height: 22px;
    font-size: 13px;
    color: #333;
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    /* white-space: nowrap; */
  }
  .baseinfo .clearfix {
    /* display: block;
    content: ''; */
    clear: both;
  }
  .baseinfo .keys .keyDetail {
    width: 310px;
    /* display: flex; */
  }
  .baseinfo .keys .keyDetail .separator {
    font-style: normal;
    font-size: 14px;
    margin-left: 4px;
  }
  .baseinfo .keys .keyDetail span {
    float: left;
    margin-right: 5px;
  }
  .highline {
    position: relative;
    clear: both;
    max-height: 66px;
    line-height: 22px;
    font-size: 13px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
  }
  .highlineFold {
    -webkit-line-clamp: inherit;
    max-height: none;
  }
  .highline .key {
    font-weight: 500;
    color: #000;
    vertical-align: top;
  }
  .highline .description {
    /* margin-left: 5px; */
    vertical-align: top;
  }
  .highline .description .desItemTitle {
    font-weight: 500;
  }
  .buttons {
    position: relative;
    height: 20px;
  }
  .buttons .more {
    float: left;
    display: inline-block;
    font-size: 13px;
    color: #0172c2;
    line-height: 1;
    padding: 3.5px 0 3.5px 18px;
    margin-right: 50px;
    cursor: pointer;
    background: url("../assets/pubmedSearch/more.png") no-repeat 0 2.5px;
    background-size: 15px;
  }
  .buttons .translate-highline {
    float: left;
    display: inline-block;
    font-size: 13px;
    color: #0172c2;
    line-height: 1;
    margin-right: 50px;
    text-align: center;
  }
  .buttons .translate-highline span {
    line-height: 1;
    padding: 3.5px 0 3.5px 18px;
    cursor: pointer;
    display: inline-block;
    background: url("../assets/pubmedSearch/translation.png") no-repeat 0 3px;
    background-size: 15px;
  }
  .buttons .loading span::after {
    content: "";
    padding-right: 14px;
    background: url("../assets/pubmedSearch/loading.gif") no-repeat center right;
    background-size: 12px;
  }
  .buttons .toggleColl {
    position: absolute;
    right: 0;
    /* top: -30px; */
    top:-14px;
    height: 23px;
  }
  .buttons .toggleColl span {
    position: relative;
    z-index: 0;
    display: inline-block;
    width: 40px;
    height: 23px;
    line-height: 23px;
    text-align: center;
    font-size: 12px;
    color: #0172c2;
    background-color: #efefef;
    -webkit-border-radius: 11.5px;
    -moz-border-radius: 11.5px;
    -ms-border-radius: 11.5px;
    border-radius: 11.5px;
    cursor: pointer;
    vertical-align: top;
  }
  .mobilePage {
    height: 48px;
    line-height: 48px;
    background-color: #d8d8d8;
    font-size: 13px;
    color: #666;
    cursor: pointer;
    text-align: center;
  }
  .mobilePage.loading::after {
    content: "";
    padding-right: 14px;
    background: url("../assets/pubmedSearch/loading.gif") no-repeat center right;
    background-size: 12px;
  }
  
  .nulllist {
    padding-top: 50px;
    padding-bottom: 50px;
    height: calc(100vh - 167px);
    box-sizing: border-box;
  }
  .nulllist p {
    margin: 0;
    padding-top: 100px;
    font-size: 13px;
    color: #888;
    background: url("../assets/pubmedSearch/no-result.png") no-repeat center top;
    background-size: 91px;
    text-align: center;
  }
  /* 详情弹框 */
  .search-result-pop {
    position: fixed;
    width: 100%;
    height: 100%;
    max-width: 100%;
    top: 0;
    left: 0;
    padding: 22px 20px 0 20px;
    border-radius: 0;
    transform: (0, 0);
    background-color: #fff;
    z-index: 12;
    box-sizing: border-box;
  }
  .search-result-pop .search-result-pop-content {
    position: relative;
    height: 100%;
    overflow-y: scroll;
  }
  .search-result-pop .title {
    font-size: 18px;
    line-height: 27px;
    color: #000;
    margin-bottom: 6px;
    font-weight: 500;
    margin-right: 75px;
  }
  .search-result-pop .author,
  .search-result-pop .from {
    /* margin-right: 60px; */
    color: #333;
    line-height: 22px;
    font-size: 13px;
  }
  .search-result-pop .yub-year,
  .search-result-pop .page-number,
  .search-result-pop .summary {
    color: #333;
    line-height: 22px;
    font-size: 13px;
  }
   .search-result-pop .keys {
    display: flex;
    color: #333;
    line-height: 22px;
    font-size: 13px;
  }
  .search-result-pop .keys span.subTitle {
    font-weight: bold;
  }
  .search-result-pop .keys .keyDetail {
    width: 218px;
  }
  .search-result-pop .keys .keyDetail span {
    float: left;
    margin-right: 5px;
  }
  .search-result-pop .keys .keyDetail .separator {
    font-style: normal;
    font-size: 14px;
    margin-left: 4px;
  }
  .search-result-pop .summary {
    /* display: flex; */
    margin-bottom: 0;
    padding-bottom: 80px;
  }
  .search-result-pop .author span,
  .search-result-pop .from span,
  .search-result-pop .yub-year span,
  .search-result-pop .page-number span,
  .search-result-pop .summary .key {
    /* width: 40px; */
    font-weight: bold;
  }
  /* .search-result-pop .summary .desBox {
    width: calc(100% - 40px)
  } */
  .search-result-pop .button-tips {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 70px;
    width: 100%;
    padding: 0 18px;
    background-color: #fff;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
  }
  .search-result-pop .buttons {
    position: relative;
    padding: 16px 20px 14px 20px;
    text-align: left;
    height: 14px;
  }
  .search-result-pop .buttons .view-fullstory {
    position: relative;
  }
  .search-result-pop .buttons .view-fullstory,
  .search-result-pop .buttons .translate-summary {
    width: 50%;
    margin: 0;
    box-sizing: border-box;
    text-align: center;
    float: left;
    display: inline-block;
    line-height: 1;
    color: #0172c2;
    font-size: 14px;
    cursor: pointer;
  }
  .search-result-pop .buttons .view-fullstory span {
    line-height: 1;
    padding: 3.5px 0 3.5px 18px;
    background: url("../assets/pubmedSearch/viewFull.png") no-repeat 0 4px;
    background-size: 15px;
  }
  .search-result-pop .buttons .translate-summary span {
    padding: 3.5px 0 3.5px 18px;
    background: url("../assets/pubmedSearch/translation.png") no-repeat 0 center;
    background-size: 15px;
  }
  .search-result-pop .close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 67px;
    height: 29px;
    line-height: 29px;
    font-size: 14px;
    text-indent: 0;
    border: 1px solid #0172c2;
    color: #0172c2;
    padding-left: 29px;
    cursor: pointer;
    -webkit-border-radius: 15px;
    -moz-border-radius: 15px;
    -ms-border-radius: 15px;
    border-radius: 15px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
    background: #fff url("../assets/pubmedSearch/close.png") no-repeat 12px 9px;
    background-size: 11px;
  }
}

@media only screen and (max-width: 413px) {
  .pcSearch {
    display: none
  }
  .mobileSearch {
    overflow: hidden;
    background: #ededed

  }
  .van-search {
    padding: 10px;
    margin:20px;
    background: #fff;
    border-radius: 15px;
  }
  .van-search__content {
    background-color: #fff;
  }
  .van-search__action {
    color: #72aaff;
    font-weight: bold;
    font-size: 15px;
  }
  .van-cell >>> .van-cell__value {
    padding-right: 7px;
    border-right: 1px solid #c5c1c1;
  }
 
  .firstNoData {
    width: 100vw;
    height: calc(100vh - 95px);
    background: #ededed;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .firstNoData img {
      width: 260px;
  } 
  .firstNoData .pcNodata {
    display: none;
  }
  .search-root {
    background: #f4f4f4;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .searchBlock {
    background: #fff;
    border-radius: 8px;
    margin: 0 10px;
  }
  .search-form {
    position: relative;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
  .icon {
    display: none;
  }
  .inputItem {
    position: relative;
    width: 100%;
  }
  .inputItem input {
    width: 100%;
    height: 48px;
    line-height: inherit;
    margin-bottom: 10px;
    padding: 0 13px;
    border: none;
    font-size: 15px;
    outline: none;
    box-shadow: none;
    border-radius: 8px;
    background-color: #f3f3f3;
    box-sizing: border-box;
  }
  input::-webkit-input-placeholder {
    color: #666666;
    font-size: 15px;
  }
  .searchBtn {
    height: 40px;
    width: 100%;
    font-size: 16px;
    text-indent: 0;
    color: #fff;
    background: #0172c2;
    border-radius: 23px;
    text-align: center;
    line-height: 40px;
  }

  .hisList {
    position: absolute;
    left: 30px;
    top: 75px;
    min-width: 304px;
    background: #fff;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 0 0 8px 8px;
    border: 1px solid #c2c2c2;
    border-top: none;
    z-index: 14;
  }
  .hisItem {
    /* height: 61px; */
    padding: 20px 10px 20px 0;
    /* box-sizing: border-box; */
    border-top: 1px dashed #d8cfcf;
    color: #999999;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .noBorderTop {
    border-top: none;
  }
  
  .hisContext {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .hisContext img {
    margin-right: 5px;
  }
  .delHis {
    cursor: pointer;
    margin-left: 15px;
  }

  /* 内容区域 */
  .pcDrop,
  .pcPage {
    display: none;
  }
  .is_fixed {
    height: 50px;
  }
  .fixedStyle {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1
  }
  .rootBox {
    margin: 0 auto;
    background-color: #f4f4f4;
  }

  .resultItem {
    padding: 19px;
    background: #fff;
    margin-top: 5px;
  }
  .el-dropdown {
    margin-right: 25px;
  }
  .resultCount {
    text-align-last: center;
    font-size: 14px;
    color: #707070;
    line-height: 18px;
    margin-top: 5px;
  }
  .resultNum {
    color: #85b5ff;
  }
  .baseinfo .title {
    padding-right: 40px;
    font-size: 18px;
    color: #000;
    line-height: 24px;
    margin-bottom: 9px;
    font-weight: 500;
    -webkit-tap-highlight-color: transparent;
  }
  .baseinfo .title .infoIndex {
    /* color:#72aaff; */
    margin-right:3px;
    font-size:16px;
    /* font-weight: 500; */
    }
  .baseinfo::after {
    display: block;
    content: "";
    clear: both;
  }
  /* .baseinfo .author {
    width: 26%;
  } */
  /* .baseinfo .from {
    width: 50%;
  } */
  .baseinfo .author,
  .baseinfo .from,
  .baseinfo .yub-year {
    /* float: left; */
    height: 22px;
    line-height: 22px;
    font-size: 13px;
    color: #333;
    /* overflow: hidden; */
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .baseinfo .keys {
    display: flex;
    width: 100%;
    /* height: 22px; */
    line-height: 22px;
    font-size: 13px;
    color: #333;
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    /* white-space: nowrap; */
  }
  .baseinfo .clearfix {
    /* display: block;
    content: ''; */
    clear: both;
  }
  .baseinfo .keys .keyDetail {
    width: 270px;
    /* display: flex; */
  }
  .baseinfo .keys .keyDetail .separator {
    font-style: normal;
    font-size: 14px;
    margin-left: 4px;
  }
  .baseinfo .keys .keyDetail span {
    float: left;
    margin-right: 5px;
  }
  .highline {
    position: relative;
    clear: both;
    max-height: 66px;
    line-height: 22px;
    font-size: 13px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
  }
  .highlineFold {
    -webkit-line-clamp: inherit;
    max-height: none;
  }
  .highline .key {
    font-weight: 500;
    color: #000;
    vertical-align: top;
  }
  .highline .description {
    /* margin-left: 8px; */
    vertical-align: top;
  }
  .highline .description .desItemTitle {
    font-weight: 500;
  }
  .buttons {
    position: relative;
    height: 20px;
  }
  .buttons .more {
    float: left;
    display: inline-block;
    font-size: 13px;
    color: #0172c2;
    line-height: 1;
    padding: 3.5px 0 3.5px 18px;
    margin-right: 50px;
    cursor: pointer;
    background: url("../assets/pubmedSearch/more.png") no-repeat 0 2.5px;
    background-size: 15px;
  }
  .buttons .translate-highline {
    float: left;
    display: inline-block;
    font-size: 13px;
    color: #0172c2;
    line-height: 1;
    margin-right: 50px;
    text-align: center;
  }
  .buttons .translate-highline span {
    line-height: 1;
    padding: 3.5px 0 3.5px 18px;
    cursor: pointer;
    display: inline-block;
    background: url("../assets/pubmedSearch/translation.png") no-repeat 0 3px;
    background-size: 15px;
  }
  .buttons .loading span::after {
    content: "";
    padding-right: 14px;
    background: url("../assets/pubmedSearch/loading.gif") no-repeat center right;
    background-size: 12px;
  }
  .buttons .toggleColl {
    position: absolute;
    right: 0;
    /* top: -30px; */
    top:-14px;
    height: 23px;
  }
  .buttons .toggleColl span {
    position: relative;
    z-index: 0;
    display: inline-block;
    width: 40px;
    height: 23px;
    line-height: 23px;
    text-align: center;
    font-size: 12px;
    color: #0172c2;
    background-color: #efefef;
    -webkit-border-radius: 11.5px;
    -moz-border-radius: 11.5px;
    -ms-border-radius: 11.5px;
    border-radius: 11.5px;
    cursor: pointer;
    vertical-align: top;
  }
  .mobilePage {
    height: 48px;
    line-height: 48px;
    background-color: #d8d8d8;
    font-size: 13px;
    color: #666;
    cursor: pointer;
    text-align: center;
  }
  .mobilePage.loading::after {
    content: "";
    padding-right: 14px;
    background: url("../assets/pubmedSearch/loading.gif") no-repeat center right;
    background-size: 12px;
  }
  .nulllist {
    padding-top: 50px;
    padding-bottom: 50px;
    height: calc(100vh - 167px);
    box-sizing: border-box;
  }
  .nulllist p {
    margin: 0;
    padding-top: 100px;
    font-size: 13px;
    color: #888;
    background: url("../assets/pubmedSearch/no-result.png") no-repeat center top;
    background-size: 91px;
    text-align: center;
  }
  /* 详情弹框 */
  .search-result-pop {
    position: fixed;
    width: 100%;
    height: 100%;
    max-width: 100%;
    top: 0;
    left: 0;
    padding: 22px 20px 0 20px;
    border-radius: 0;
    transform: (0, 0);
    background-color: #fff;
    z-index: 12;
    box-sizing: border-box;
  }
  .search-result-pop .search-result-pop-content {
    position: relative;
    height: 100%;
    overflow-y: scroll;
  }
  .search-result-pop .title {
    font-size: 18px;
    line-height: 27px;
    color: #000;
    margin-bottom: 6px;
    font-weight: 500;
    margin-right: 75px;
  }
  .search-result-pop .author,
  .search-result-pop .from {
    /* margin-right: 60px; */
    color: #333;
    line-height: 22px;
    font-size: 13px;
  }
  .search-result-pop .yub-year,
  .search-result-pop .page-number,
  .search-result-pop .summary {
    color: #333;
    line-height: 22px;
    font-size: 13px;
  }
   .search-result-pop .keys {
    display: flex;
    color: #333;
    line-height: 22px;
    font-size: 13px;
  }
  .search-result-pop .keys span.subTitle {
    font-weight: bold;
  }
  .search-result-pop .keys .keyDetail {
    width: 179px;
  }
  .search-result-pop .keys .keyDetail span {
    float: left;
    margin-right: 5px;
  }
  .search-result-pop .keys .keyDetail .separator {
    font-style: normal;
    font-size: 14px;
    margin-left: 4px;
  }
  .search-result-pop .summary {
    /* display: flex; */
    margin-bottom: 0;
    padding-bottom: 80px;
  }
  .search-result-pop .author span,
  .search-result-pop .from span,
  .search-result-pop .yub-year span,
  .search-result-pop .page-number span,
   .search-result-pop .summary .key {
    /* width: 40px; */
    font-weight: bold;
  }
  /* .search-result-pop .summary .desBox {
    width: calc(100% - 40px)
  } */
  .search-result-pop .button-tips {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 70px;
    width: 100%;
    padding: 0 18px;
    background-color: #fff;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
  }
  .search-result-pop .buttons {
    position: relative;
    padding: 16px 20px 14px 20px;
    text-align: left;
    height: 14px;
  }
  .search-result-pop .buttons .view-fullstory {
    position: relative;
  }
  .search-result-pop .buttons .view-fullstory,
  .search-result-pop .buttons .translate-summary {
    width: 50%;
    margin: 0;
    box-sizing: border-box;
    text-align: center;
    float: left;
    display: inline-block;
    line-height: 1;
    color: #0172c2;
    font-size: 14px;
    cursor: pointer;
  }
  .search-result-pop .buttons .view-fullstory span {
    line-height: 1;
    padding: 3.5px 0 3.5px 18px;
    background: url("../assets/pubmedSearch/viewFull.png") no-repeat 0 4px;
    background-size: 15px;
  }
  .search-result-pop .buttons .translate-summary span {
    padding: 3.5px 0 3.5px 18px;
    background: url("../assets/pubmedSearch/translation.png") no-repeat 0 center;
    background-size: 15px;
  }
  .search-result-pop .close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 67px;
    height: 29px;
    line-height: 29px;
    font-size: 14px;
    text-indent: 0;
    border: 1px solid #0172c2;
    color: #0172c2;
    padding-left: 29px;
    cursor: pointer;
    -webkit-border-radius: 15px;
    -moz-border-radius: 15px;
    -ms-border-radius: 15px;
    border-radius: 15px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
    background: #fff url("../assets/pubmedSearch/close.png") no-repeat 12px 9px;
    background-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue